/**
 * DiCon Incident Service API
 * API used by DiCon, LiOn and Buefo.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: dienstleistung@netze-bw.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatMessageUserType } from './chatMessageUserType';


/**
 * Chat message object
 */
export interface ChatMessageTOV2 { 
    /**
     * Chat message Uuid
     */
    chatMessageUuid?: string;
    /**
     * Chat message
     */
    message: string;
    /**
     * Sender name
     */
    createdBy: string;
    /**
     * Sender email address
     */
    createdByEmail: string;
    chatUserType: ChatMessageUserType;
    /**
     * Is read be LiOnUser
     */
    isReadByLionUser: boolean;
    createDateTimeUtc?: string;
}
export namespace ChatMessageTOV2 {
}


